import script from "./SidebarComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarComponent.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarComponent.vue?vue&type=style&index=0&id=ec208ed8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec208ed8"]])

export default __exports__